import {
  CHAIN_IDS_SUPPORT_INTENTS,
  NETWORK_NAME_PER_CHAIN_ID,
  SUPPORTED_CHAINS_BY_CHAIN_ID,
} from '@/constants/chain';

import { fontStyles } from '@/styles/typography';

import { AvatarStack } from '@/ui/Avatars/AvatarStack';
import { ChainAvatar, chainAvatarRadius } from '@/ui/Avatars/ChainAvatar';
import {
  MatchaTooltip,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

import { Section, SectionBody } from '../../Section';

export const MatchaAutoAvailableSection = () => {
  const supportedChainNames = CHAIN_IDS_SUPPORT_INTENTS.map(
    (chainId) => SUPPORTED_CHAINS_BY_CHAIN_ID[chainId].name,
  );

  return (
    <Section>
      <SectionBody>
        <div
          className={fontStyles({
            variant: 'BODY_SM',
            class:
              'text-token-gray-800 bg-token-gray-200 shadow-inner-05 flex rounded-md p-2.5 -my-4',
          })}
        >
          Available on
          <MatchaTooltip>
            <MatchaTooltipTrigger>
              <AvatarStack
                className="px-1 inline-flex self-baseline"
                size={16}
                overlap={2}
                borderRadius={chainAvatarRadius}
              >
                {CHAIN_IDS_SUPPORT_INTENTS.map((chainId) => (
                  <ChainAvatar
                    key={chainId}
                    chainId={chainId}
                    alt={`${NETWORK_NAME_PER_CHAIN_ID[chainId]} logo`}
                    size={16}
                  />
                ))}
              </AvatarStack>
            </MatchaTooltipTrigger>
            <MatchaTooltipContent>{supportedChainNames.join(', ')}</MatchaTooltipContent>
            <MatchaTooltipPopover />
          </MatchaTooltip>
          for supported trading pairs.
        </div>
      </SectionBody>
    </Section>
  );
};
